import 'antd/lib/table/style';
//# sourceMappingURL=index.js.map